import PropTypes from 'prop-types'
import { Input, Button, InputGroup, InputGroupAddon } from 'reactstrap'
import { WEB_URL_CONSTANTS } from 'constants/web-url-constants'

const propTypes = {
  onChange      : PropTypes.func,
  onClickSearch : PropTypes.func
}

const VoucherSearchInput = ({
  onChange,
  onClickSearch
}) => (
  <InputGroup>
    <InputGroupAddon addonType="prepend">
      <img className='px-2' src={ `${WEB_URL_CONSTANTS.HOMEPAGE}/icons/voucher.svg` }/>
    </InputGroupAddon>
    <Input
      onChange={ onChange }
      placeholder="Search Voucher Code"
    />
    <InputGroupAddon addonType="append">
      <Button
        color="primary"
        onClick={ onClickSearch }
      >
        { 'Search' }
      </Button>
    </InputGroupAddon>
  </InputGroup>
)

VoucherSearchInput.propTypes = propTypes

export default VoucherSearchInput